import { Action } from 'redux'

export interface RedirectToProgressionPage extends Action {
  payload: boolean
  type: 'DX/REDIRECT_TO_PROGRESSION_PAGE'
}

export const redirectToProgressionPage = (
  value: boolean = true
): RedirectToProgressionPage => {
  return {
    type: 'DX/REDIRECT_TO_PROGRESSION_PAGE',
    payload: value,
  }
}
